export const orStyles = {
  mt: "16px",
  fontSize: "16px",
  fontWeight: "Medium",
  textAlign: "center",
};

export const DoneIconStyle = {
  backgroundColor: "var(--primary-color)",
  fontSize: "130px",
  color: "white",
  borderRadius: "50%",
  border: "10px solid #fee5b1",
  padding: "10px",
  mb: "1rem",
};

export const loginBtnStyles = {
  width: "100%",
  padding: "8px 16px",
  borderRadius: "30px",
  marginTop: "1rem",
  fontSize: "16px",
  fontWeight: "500",
};

export const loginSecondBtnStyles = {
  ...loginBtnStyles,
  backgroundColor: "#F5F4F4",
  color: "black",
  boxShadow: "0 0 10px rgba(0,0,0,0.2)",
};
export const formHeadingStyles = { my: 1, fontSize: "18px", fontWeight: 500 };

export const formTextStyles = {
  fontSize: "12px",
  fontWeight: 500,
  color: "rgba(0,0,0,0.4)",
  textAlign: "center",
};

export const formBoxStyles = {
  mt: 0,
  width: "100%",
  display: "flex",
  flexDirection: "column",
  gap: "0.15rem",
};
